import styled from "styled-components";

export const SelectContOuter = styled.div`
    position: relative;
`;
export const SelectCont = styled.div`
    align-items: center;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 10px 0 rgb(0 0 0 / 20%);
    color: #000;
    display: flex;
    font-weight: 700;
    padding: 15px;
    position: relative;
    cursor: pointer;
    &::after{
        content: "";
        border: solid #008cff;
        border-width: 0 2px 2px 0;
        padding: 3px;
        transform: rotate(45deg);
        margin-left: auto;
    }
    ${p => p.toggle && `
        box-shadow: none;
        border-bottom: 1px solid #cacaca;
        padding: 15px 15px 15px 0;
        border-radius: 0;
        &::after{
            transform: rotate(-135deg);
        }   
    `}
`;
export const Flag = styled.span`
    width: 16px;
    height: 12px;
    flex-shrink: 0;
    margin-right: 10px;
    border-radius: 2px;
    overflow: hidden;
    > img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;
export const SelectList = styled.div`
    width: 100%;
    background-color: #fff;
    li{
        align-items: center;
        border-bottom: 1px solid #f3f3f3;
        color: #000;
        cursor: pointer;
        display: flex;
        font-size: 14px;
        font-weight: 700;
        padding: 10px 0;
    }
`;
export const GreenIcon = styled.span`
    background: #26b5a9;
    border-radius: 100%;
    display: flex;
    flex-shrink: 0;
    height: 12px;
    justify-content: center;
    padding-top: 3px;
    position: relative;
    width: 12px;
    margin-left: 10px;
    &::after{
        border: 1px solid #fff;
        border-right: none;
        border-top: none;
        content: "";
        height: 3px;
        transform: rotate(-50deg);
        width: 7px;
    }
`;